import { render, staticRenderFns } from "./DeleteGroupTournament.vue?vue&type=template&id=3e55a6ca&scoped=true"
import script from "./DeleteGroupTournament.vue?vue&type=script&lang=js"
export * from "./DeleteGroupTournament.vue?vue&type=script&lang=js"
import style0 from "./DeleteGroupTournament.vue?vue&type=style&index=0&id=3e55a6ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e55a6ca",
  null
  
)

export default component.exports